import { Button, ButtonGroup, Collapse, Intent } from '@blueprintjs/core'
import { APOLLO_FIELD_FILTER_TYPE, IAppoloField, ID, IMetaFilter, IPaging, ITaxonomyFilter } from '@libs/interfaces/layouts'
import { apolloFields } from '@libs/layouts'
import { SCALAR_TYPES } from '@libs/scalars'
import { __ } from '@libs/utilities'
import { IState, SORT_ORDER, useMainStore } from '@settings/zustand'
import { useEffect, useState } from 'react'
import { IBulk } from '../../data/interfaces'
import { IAdminStore, useAdminStore } from '../../data/store'
import BulkDeleter from './BulkDeleter'
import BulkDuplicator from './BulkDuplicator'
import BulkEditor from './BulkEditor'
import BulkVisibler from './BulkVisibler'
import DataTableSearchPanel from './DataTableSearchPanel'
import DataTableSettingsPanel from './DataTableSettingsPanel'
import MetaFilterElement from './MetaFilterElement'
import TaxonomyFilterElement from './TaxonomyFilterElement'

const DataTableFiltersPanel = (props: IDataTableFilterProps): JSX.Element => {
    const bulks: IBulk[]                        = useAdminStore((state:IAdminStore) => state.bulks) 
    const search: string                        = useAdminStore((state:IAdminStore) => state.search) 
    const metaFilter                            = useAdminStore((state:IAdminStore) => state.metaFilter) 
    const post_status                           = useAdminStore((state:IAdminStore) => state.post_status) 
    const in__roles                             = useAdminStore((state:IAdminStore) => state.in__roles) 
    const setMetaFilter                         = useAdminStore((state:IAdminStore) => state.setMetaFilter) 
    const setPost_status                        = useAdminStore((state:IAdminStore) => state.setPost_status) 
    const setIn__roles                          = useAdminStore((state:IAdminStore) => state.setIn__roles) 
    const setSearch                             = useAdminStore((state:IAdminStore) => state.setSearch) 
    const setTaxonomies                         = useAdminStore((state:IAdminStore) => state.setTaxonomies) 
    const setSortOrder: any                     = useAdminStore((state: IAdminStore ) => state.setSortOrder)
    const landId : ID                           = useMainStore((state: IState) => state.landId ) 
    const [metaFilters, setMetaFilters]         = useState<any[]>( [] ) 
    const [relation, setRelation]               = useState<"OR" | "AND" >( 'OR' )
    const [isSettingsOpen, setIsSettingsOpen]   = useState( false )
    const [isFilterOpen, setIsFilterOpen]       = useState( false ) 


    useEffect(() => {
        onSetFilters()
    }, [ props.data_type ]) 

    const getMetaValue = (field: IAppoloField, i:number): any => { 
        switch( field.type ) {
            case SCALAR_TYPES.POST_STATUS:
                return post_status
            default: 
                const ff = metaFilter.filter(( mF: IMetaFilter ) => mF.key === field.name ) 
                return ff[0]?.value
        }
    }
    const onFilter = ( key: string, value: any ) => {
        let _in__roles: string[] | null = useAdminStore.getState().in__roles

        //console.log( useAdminStore.getState().metaFilter, key ) 

        let _metas = [ ...useAdminStore.getState().metaFilter ].filter( m => m.key !== key )  
        if( key === "roles" && props.data_type === "User" ) { 
            _in__roles = value
        }
        else if(key === SCALAR_TYPES.POST_STATUS) {
            setPost_status( value )
        }
        else if( value !== null && ( value?.length !==  0) ) { 
            _metas.push({ key, value} as IMetaFilter )
        }
    
        setMetaFilter( _metas ) 
        setIn__roles( _in__roles )
        onSetPaging()
    }

    const onTaxonomy = (tax_name:string, term_ids: Number[]) => { 
        let _taxonomies = (useAdminStore.getState().taxonomies || [])
            .filter( (t: ITaxonomyFilter) => t.tax_name !== tax_name )
        _taxonomies.push({tax_name, term_ids})
        console.log(_taxonomies)
        setTaxonomies(_taxonomies)
        onSetPaging()
    }

    const onSearch =(_search: string) => {
        setSearch(_search)
        onSetPaging()
    }

    const clearFilter = () => {
        setMetaFilter([])
        setIn__roles(null)
        setRelation("OR")
        onSetFilters()
        props.clearFilter()
    }

    const onSetPaging = () => {
        let paging: IPaging = {
            metas:          useAdminStore.getState().metaFilter,
            in__roles :     useAdminStore.getState().in__roles,
            post_status:    useAdminStore.getState().post_status,
            relation:       relation,
            search:         useAdminStore.getState().search,
            taxonomies:     useAdminStore.getState().taxonomies,
        } 
        if( props.onFilter ) {
            props.onFilter(paging)
        }
    } 

    const onSort = ( order: SORT_ORDER, byField: string ) => { 
        // setSortOrder( order.toUpperCase() )
    }

    const onSetFilters = () => {
         // set filters and meta_filters
         const fields: IAppoloField[] = Object.keys( apolloFields( props.data_type ) ).map( af => {
            return { ...apolloFields( props.data_type )[af], name: af }
        } )
        const _metaFilters: any[] = []
        fields.forEach( (field: IAppoloField, i: number) => { 
            if( field.filter_type === APOLLO_FIELD_FILTER_TYPE.TAXONOMIES ) {
                _metaFilters.push(
                    <TaxonomyFilterElement 
                        key={ i } 
                        field={ field } 
                        onFilter = { onTaxonomy }
                    /> 
                )
            }
            if( field.filter_type === APOLLO_FIELD_FILTER_TYPE.META ) { 
                //console.log( field.name, field.type ) 
                _metaFilters.push(
                    <MetaFilterElement 
                        key={ i } 
                        field={ field } 
                        onFilter = { onFilter }
                        value={ getMetaValue( field, i ) }
                    /> 
                )
            }
        }) 
        setMetaFilters(_metaFilters)
    }

    const filterBtn = !!metaFilters.length
	    ?
		<Button 
            variant="minimal" 
            icon={ isFilterOpen ? "filter-remove" : "filter" }
            onClick={ () => setIsFilterOpen(!isFilterOpen ) }
            data-testid="data-table-hide-filter-button"
        >
			<div className="descr">
                { __(isFilterOpen ? "hide Filters" : "show Filters") }
            </div>
		</Button>
	    :			
		null
	
    const filterBlock = !!metaFilters.length 
	    ? 
        <Collapse isOpen={isFilterOpen} className="w-100">
            <div className="p-3 pe-light mt-2" data-testid="data-table-filter-panel">
                <div className="d-flex flex-wrap mb-2"> 
                    { metaFilters }
                </div>
                <div className="d-flex flex-wrap">
                    <ButtonGroup className="flex-wrap ">
                        <Button
                            variant={relation === "AND" ? "minimal" : "solid"}
                            intent={Intent.SUCCESS}
                            data-relation="OR"
                            onClick={() => {
                                setRelation('OR')
                                onSetPaging()
                            }}
                            data-testid="data-table-or-button"
                        >
                            <div className={`descr  ${relation === "AND" ? "" : "text-light-force"}`}> 
                                { __("All by any fields")} 
                            </div>
                        </Button>
                        <Button
                            variant={relation === "OR" ? "minimal" : "solid"}
                            intent={Intent.DANGER}
                            data-relation="AND"
                            onClick={() => {
                                setRelation('AND');
                                onSetPaging()
                            }}
                            data-testid="data-table-and-button"
                        >
                            <div className={`descr ${relation === "OR" ? "" : "text-light-force"}`}>
                                {__("Only have all fields")}
                            </div>
                        </Button>
                    </ButtonGroup>
                    <Button variant="minimal" onClick={ clearFilter } className="ml-3 w-32 w-sm-100" data-testid="data-table-clear-filter-button">
                        <div className={`descr`}>
                            { __("clear filters") }
                        </div>
                    </Button>
                </div>
            </div>
        </Collapse> 
	    :			
		null 



    
    return <>
        <div className="d-flex w-100 align-items-center ">
            <Button
                variant="minimal"
                className="ml-2"
                icon="cog"
                onClick={() => setIsSettingsOpen( !isSettingsOpen )}
                data-testid="data-table-hide-setting-button"
            >
                <div className="descr">
                    { __( isSettingsOpen ? "hide Settings" : "show Settings") }
                </div>
            </Button>
            { filterBtn }
            <div className="ml-auto">
                <DataTableSearchPanel search={search} onSearch={onSearch} />               
            </div> 
        </div>
        <Collapse isOpen={ isSettingsOpen } className="w-100">
            <DataTableSettingsPanel data_type={props.data_type} onSort={onSort}/>
        </Collapse>
		{ filterBlock } 
        <Collapse isOpen={ !!bulks.filter((bulk: IBulk) => bulk.checked).length } className="w-100">
            <div className="p-3 pe-light mt-2 border-bottom-dark">
                <ButtonGroup className="d-flex align-items-center flex-wrap">
                    <BulkDeleter data_type={props.data_type}/> 
                    <BulkEditor data_type={props.data_type} landId={landId} /> 
                    <BulkDuplicator onConfirm={ () => { if( props.onDoubled) props.onDoubled() } }/> 
                    <BulkVisibler data_type={props.data_type}/>                    
                </ButtonGroup>
            </div>
        </Collapse>
    </>
} 

export default DataTableFiltersPanel

export interface IDataTableFilterProps {
    data_type: string
    data_status?: string
    count: number
    onChangeCount : ( count: number ) => void
    clearFilter : () => void
    onFilter?: ( paging: IPaging ) => void
    onDoubled?: () => void 
}